// ✅ Updated Bonus.jsx (i18n ready)
// - Added useTranslation()
// - All UI strings moved to t("bonus....")
// - excellentdairy values remain SAME (type: "liter"/"per", dates, etc.)
// - Dropdown default values changed to stable keys (no Marathi hardcode in values)
// - Excel filename translated via i18n (still includes dates)
// NOTE: Keep remaining logic as-is; only string replacements + minor select default value fixes

import React, { useEffect, useState, useRef } from 'react'
import './Bonus.css'
import { ToastContainer, toast } from 'react-toastify';
import back from "../../imgs/backexam.png";
import close from "../../imgs/close.png";
import { Co2Sharp, Face6TwoTone, FaxTwoTone } from '@mui/icons-material';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import Billprint from '../Billprint/Billprint';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useTranslation } from "react-i18next";

const toNum = (v) => (v == null || v === '' || isNaN(v) ? 0 : Number(v));
const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

// Pull config from `input` first, fall back to localStorage
const getCalcConfig = (input) => {
  const type = String(input?.type ?? localStorage.getItem('type') ?? '').toLowerCase();
  const isPer = type === 'per';
  const mhRate = toNum(input?.mhrate ?? localStorage.getItem('mhrate'));
  const gyRate = toNum(input?.gayrate ?? localStorage.getItem('gayrate'));
  return { isPer, mhRate, gyRate };
};

// If you want totals to EXACTLY match the sum of the displayed (2-dec) cells,
// set `roundEachRow=true`. Otherwise leave it false to sum full precision.
const computeTotals = (rows, cfg, roundEachRow = false) => {
  return (Array.isArray(rows) ? rows : []).reduce((acc, r) => {
    const thev = toNum(r.thevamt);

    const mhliter = toNum(r.mhliter);
    const gyliter = toNum(r.gayliter);

    const mh = cfg.isPer ? toNum(r.mhamt) : toNum(r.mhliter);
    const gy = cfg.isPer ? toNum(r.gayamt) : toNum(r.gayliter);

    const mhamt = toNum(r.mhamt);
    const gyamt = toNum(r.gayamt);

    let mhBonus = cfg.isPer ? (mh * cfg.mhRate) / 100 : (mh * cfg.mhRate);
    let gyBonus = cfg.isPer ? (gy * cfg.gyRate) / 100 : (gy * cfg.gyRate);

    if (roundEachRow) {
      mhBonus = round2(mhBonus);
      gyBonus = round2(gyBonus);
    }

    acc.thevamt += thev;
    acc.mhliter += mhliter;
    acc.mhamt += mhamt;
    acc.gayliter += gyliter;
    acc.gayamt += gyamt;
    acc.mhBonus += mhBonus;
    acc.gyBonus += gyBonus;
    return acc;
  }, { thevamt: 0, mhliter: 0, gayliter: 0, mhBonus: 0, gyBonus: 0, mhamt: 0, gayamt: 0 });
};

const Bonus = (props) => {
  const { t } = useTranslation();

  const [input, setInput] = useState({
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    mhrate: 1,
    gayrate: 1,
    type: "liter",          // ✅ excellentdairy value stays
    thevdesign: "1",
    knofrom: "",
    knoto: "",
    mobileuser: ""          // ✅ value stays (name)
  });

  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);
  const [DataSource, setDataSource] = useState([]);
  const [DataSource2, setDataSource2] = useState([]);
  const [wait, setWait] = useState(false);
  const [showthevcol, setShowthevcol] = useState("No");
  const [mobileusers, setMobileusers] = useState([]);
  const refthevtype = useRef(null);
  const refthevtypeclose = useRef(null);

  const handlethevtype = () => refthevtype.current.click();
  const handlethevtypeclose = () => refthevtypeclose.current.click();

  const handleChange = async (event) => {
    const name = event.target.name;
    let valuecurrent = event.target.value;

    // default set
    setInput(v => ({ ...v, [name]: valuecurrent }));

    if (name === 'date2') {
      const date1 = new Date(input.date1);
      const date2 = new Date(valuecurrent);
      const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000;
      if (date2 - date1 <= oneYearInMilliseconds) {
        setInput((prev) => ({ ...prev, [name]: valuecurrent }));
      } else {
        notifyerror(t("bonus.toast.reportLimit1Year"));
        setInput((prev) => ({ ...prev, [name]: new Date().toISOString().substr(0, 10) }));
      }
    }
  }

  useEffect(() => {
    getthevmaxdate();
    getmobileusers();
  }, [])

  async function getmobileusers() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios.post('https://excellentdairy.com/dairy/php/cust/getmobileusers.php',
      { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }
    ).then(function sample(response) {
      if (response.data) setMobileusers(response.data);
    }).catch(err => console.log(err));
  }

  const getthevmaxdate = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    let rawData = { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://excellentdairy.com/dairy/php/cust/getthevmaxdate.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      if (response.data && response.data.length > 0) setDataSource2(response.data);
    }).catch(err => console.log(err));
  }

  const showprint = () => {
    if (DataSource && DataSource.length > 0) {
      localStorage.setItem("date1print", input.date1);
      localStorage.setItem("date2print", input.date2);
      localStorage.setItem("knofrom", input.knofrom);
      localStorage.setItem("knoto", input.knoto);
      localStorage.setItem("mhrate", input.mhrate);
      localStorage.setItem("gayrate", input.gayrate);
      localStorage.setItem("type", input.type);            // ✅ excellentdairy value
      localStorage.setItem("printdesign", input.thevdesign);
      localStorage.setItem("showthevcol", showthevcol);
      localStorage.setItem("mobileuser", input.mobileuser);
      window.open("/bonusprint", '_blank');
    } else {
      notifyerror(t("bonus.toast.noCollectionForPeriod"));
    }
  }

  const getbonusreport = () => {
    if (input.knofrom === "" || input.knoto === "") {
      notifyerror(t("bonus.toast.fillAccountNo"));
      return;
    }
    setWait(true);

    var mainuser2 = jsEncode.encode("mamapr", 125);
    let rawData = {
      date1: input.date1,
      date2: input.date2,
      type: input.type,              // ✅ excellentdairy value stays
      knofrom: input.knofrom,
      knoto: input.knoto,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      mobileuser: input.mobileuser
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://excellentdairy.com/dairy/php/cust/getbonusreport4.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      if (response.data && response.data.length > 0) {
        setDataSource(response.data);
        setWait(false);
      } else {
        notifyerror(t("bonus.toast.tryAgain"));
        setDataSource([]);
        setWait(false);
      }
    }).catch(err => {
      console.log(err);
      setWait(false);
    });
  }

  const exportToExcel = () => {
    let wb = XLSX.utils.table_to_book(document.getElementById('myTablebill'), { sheet: "Sheet JS" });
    const ws = wb.Sheets["Sheet JS"];

    // (kept as your original)
    ws['!cols'] = [
      { wch: 8 }, { wch: 30 }, { wch: 20 }, { wch: 20 },
      { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
      { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 20 },
    ];

    const range = XLSX.utils.decode_range(ws['!ref']);

    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cell = ws[XLSX.utils.encode_cell({ r: R, c: 9 })];
      if (cell && typeof cell.v === 'string') cell.v = cell.v.replace(/\//g, '-');
    }

    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cell = ws[XLSX.utils.encode_cell({ r: R, c: 2 })];
      if (cell) {
        let cellValue = cell.v.toString();
        if (!cellValue.startsWith('A')) cell.v = `'A${cellValue}`;
        cell.t = 's';
      }
    }

    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cell = ws[XLSX.utils.encode_cell({ r: R, c: 2 })];
      if (cell) { cell.v = cell.v.toString(); cell.t = 's'; }
    }

    for (let C = 0; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (ws[cellAddress]) {
        ws[cellAddress].s = ws[cellAddress].s || {};
        ws[cellAddress].s.fill = { patternType: "solid", fgColor: { rgb: "ADD8E6" } };
        ws[cellAddress].s.font = { bold: true };
      }
    }

    XLSX.writeFile(wb, `${t("bonus.excel.filePrefix")} (${input.date1} ${t("bonus.to")} ${input.date2}).xlsx`);
  };

  useEffect(() => {
    const from = (input.knofrom ?? "").trim();

    if (from === "") {
      if (input.knoto !== "") setInput(prev => ({ ...prev, knoto: "" }));
      return;
    }

    const n = Number(from);
    if (!Number.isFinite(n)) return;

    const nextKnoto = String(n + 49);
    if (input.knoto !== nextKnoto) setInput(prev => ({ ...prev, knoto: nextKnoto }));
  }, [input.knofrom]);

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const isPer = String(input?.type || '').toLowerCase() === 'per';
  const mhRate = toNum(input?.mhrate);
  const gyRate = toNum(input?.gayrate);

  const handleChangeactive = (event) => {
    setShowthevcol(event.target.checked ? "Yes" : "No");
  }

  const cfg = getCalcConfig(input);
  const totals = computeTotals(DataSource, cfg, true);

  const buffaloRateLabel = input.type === "per"
    ? t("bonus.rate.buffaloPer")
    : t("bonus.rate.buffaloPerLiter");

  const cowRateLabel = input.type === "per"
    ? t("bonus.rate.cowPer")
    : t("bonus.rate.cowPerLiter");

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden={true}
        ref={refthevtype}
        data-bs-target="#thevtype"
      />

      <div className="modal fade" id="thevtype" tabIndex="-1" role="dialog" aria-hidden="true" >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refthevtypeclose} aria-label="Close" />
            </div>
            <div className="modal-body">
              <h4 className="modal-title">{t("bonus.modal.printDesignTitle")}</h4>

              <div className="mb-2">
                <span className='subheadsank'>{t("bonus.modal.bonusPrintDesign")}</span>
                <select value={input.thevdesign} name='thevdesign' id='thevdesign' onChange={handleChange} className={"form-control"}>
                  <option value="1">{t("bonus.modal.printCombined")}</option>
                  <option value="2">{t("bonus.modal.printMemberWise")}</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handlethevtypeclose}>{t("bonus.btn.no")}</button>
              <button type="button" className="btn btn-danger" onClick={showprint}>{t("bonus.btn.yes")}</button>
            </div>
          </div>
        </div>
      </div>

      <div className="sanklanmain">
        <div className="firstrowsank">
          <img onClick={props.visibility} className='back' src={back} alt="" />
          <div className="colmainbill">
            <div className="firstrowbill">
              <div className="rowbill">

                <div className="mb-2">
                  <span className='subheadsank'>{t("bonus.label.date")}</span>
                  <input type="date" className="form-control" autoComplete='off' id="date1bonus" name="date1" value={input.date1} onChange={handleChange} />
                </div>

                <span className='subheadbill'>{t("bonus.to")}</span>

                <div className="mb-2">
                  <span className='subheadsank'>{t("bonus.label.date")}</span>
                  <input type="date" className="form-control" autoComplete='off' id="date2bonus" name="date2" value={input.date2} onChange={handleChange} />
                </div>

                <span className='subheadbill se'> || </span>

                <div className="mb-2 se">
                  <span className='subheadsank'>{t("bonus.label.accFrom")}</span>
                  <input type="text" className="form-control" autoComplete='off' id="knofrombonus" name="knofrom" value={input.knofrom} onChange={handleChange} />
                </div>

                <span className='subheadbill'>{t("bonus.to")}</span>

                <div className="mb-2">
                  <span className='subheadsank'>{t("bonus.label.accTo")}</span>
                  <input disabled type="text" className="form-control" autoComplete='off' id="knotobonus" name="knoto" value={input.knoto} onChange={handleChange} />
                </div>

                <div className="mb-2">
                  <span className='subheadsank'>{t("bonus.label.bonusType")}</span>
                  <select value={input.type} name='type' id='typebonus' onChange={handleChange} className={"form-control"}>
                    {/* ✅ value is stable for logic */}
                    <option value="select">{t("bonus.selectType")}</option>
                    <option value="liter">{t("bonus.type.literWise")}</option>
                    <option value="per">{t("bonus.type.perWise")}</option>
                  </select>
                </div>

                <div className="mb-2">
                  {wait ? (
                    <button type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("bonus.btn.loading")}</button>
                  ) : (
                    <button onClick={getbonusreport} type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("bonus.btn.viewReport")}</button>
                  )}
                  <button onClick={exportToExcel} type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("bonus.btn.excel")}</button>
                  <button onClick={handlethevtype} type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("bonus.btn.print")}</button>
                </div>

                <div className="rowbill bonusbox">
                  <div className="mb-2 bonustext2">
                    <span className='subheadsank'>{buffaloRateLabel}</span>
                    <input type="text" className="form-control bonustext" autoComplete='off' id="mhrate" name="mhrate" value={input.mhrate} onChange={handleChange} />
                  </div>

                  <div className="mb-2 bonustext2">
                    <span className='subheadsank'>{cowRateLabel}</span>
                    <input type="text" className="form-control bonustext" autoComplete='off' id="gayrate" name="gayrate" value={input.gayrate} onChange={handleChange} />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="firstrowsank">
          <div className="form-check thevcheckbox">
            <input className="form-check-input" type="checkbox" value="" onChange={handleChangeactive} id="activestatus" />
            <span className="checklbl" htmlFor="activestatus">
              {t("bonus.label.thevColumn")}
            </span>
          </div>

          <span id='divbonus'> || </span>

          <div className="mb-2">
            <select className={"form-control"} autoComplete='off' id="mobileuserbonus" name="mobileuser" value={input.mobileuser} onChange={handleChange}>
              <option value="">{t("bonus.selectMobileUser")}</option>
              {mobileusers ? mobileusers.map((opt2, index) => (
                <option key={index + 1} value={opt2.name}>{opt2.name}</option>
              )) : ""}
            </select>
          </div>
        </div>

        <div className="firstrow2">
          <div className="table-containerthev">
            <table id="myTablebill" className="table table-bordered">
              <thead>
                <tr>
                  <th className='thsmall'>{t("bonus.table.accNo")}</th>
                  <th className='thlarge'>{t("bonus.table.name")}</th>
                  <th className='thlarge'>{t("bonus.table.bankAcc")}</th>

                  {showthevcol === "Yes" ? (
                    <th className='thsmall'>{t("bonus.table.thevAmt")}</th>
                  ) : null}

                  <th className='thsmall'>{t("bonus.table.buffaloLiter")}</th>
                  <th className='thsmall'>{t("bonus.table.buffaloAmt")}</th>
                  <th className='thsmall'>{t("bonus.table.buffaloBonus")}</th>

                  <th className='thsmall'>{t("bonus.table.cowLiter")}</th>
                  <th className='thsmall'>{t("bonus.table.cowAmt")}</th>
                  <th className='thsmall'>{t("bonus.table.cowBonus")}</th>

                  <th className='thsmall'>{t("bonus.table.totalBonus")}</th>

                  {showthevcol === "Yes" ? (
                    <th className='thsmall'>{t("bonus.table.thevPlusBonus")}</th>
                  ) : null}
                </tr>
              </thead>

              <tbody>
                {Array.isArray(DataSource) && DataSource.map((user, index) => {
                  const thevamt = toNum(user.thevamt);

                  const mhliter = toNum(user.mhliter);
                  const mh = isPer ? toNum(user.mhamt) : toNum(user.mhliter);
                  const mhamt = toNum(user.mhamt);

                  const gyliter = toNum(user.gayliter);
                  const gy = isPer ? toNum(user.gayamt) : toNum(user.gayliter);
                  const gyamt = toNum(user.gayamt);

                  const mhBonus = isPer ? (mh * mhRate) / 100 : (mh * mhRate);
                  const gyBonus = isPer ? (gy * gyRate) / 100 : (gy * gyRate);

                  return (
                    <tr key={index}>
                      <td className='thsmall'>{user.kno}</td>
                      <td className='thsmall'>{user.cname}</td>
                      <td className='thsmall'>{user.accno}</td>

                      {showthevcol === "Yes" ? (
                        <td className='thsmall'>{thevamt.toFixed(2)}</td>
                      ) : null}

                      <td className='thsmall2'>{mhliter.toFixed(2)}</td>
                      <td className='thsmall2'>{mhamt.toFixed(2)}</td>
                      <td className='thsmall2'>{mhBonus.toFixed(2)}</td>

                      <td className='thsmall2'>{gyliter.toFixed(2)}</td>
                      <td className='thsmall2'>{gyamt.toFixed(2)}</td>
                      <td className='thsmall2'>{gyBonus.toFixed(2)}</td>

                      <td className='thsmall2'>{(mhBonus + gyBonus).toFixed(2)}</td>

                      {showthevcol === "Yes" ? (
                        <td className='thsmallgreenbonus'>{(mhBonus + gyBonus + (thevamt ? thevamt : 0)).toFixed(2)}</td>
                      ) : null}
                    </tr>
                  );
                })}
              </tbody>

              <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                <td className='thsmallcust'>{t("bonus.table.total")}</td>
                <td className='thsmallcust'>-</td>
                <td className='thsmallcust'>-</td>

                {showthevcol === "Yes" ? (
                  <td className='thsmallcust'>{totals.thevamt.toFixed(2)}</td>
                ) : null}

                <td className='thsmallcust'>{totals.mhliter.toFixed(2)}</td>
                <td className='thsmall2'>{totals.mhamt.toFixed(2)}</td>
                <td className='thsmallcust'>{totals.mhBonus.toFixed(2)}</td>

                <td className='thsmallcust'>{totals.gayliter.toFixed(2)}</td>
                <td className='thsmall2'>{totals.gayamt.toFixed(2)}</td>
                <td className='thsmallcust'>{totals.gyBonus.toFixed(2)}</td>

                <td className='thsmallcust'>{(totals.mhBonus + totals.gyBonus).toFixed(2)}</td>

                {showthevcol === "Yes" ? (
                  <td className='thsmallcust'>{(totals.mhBonus + totals.gyBonus + totals.thevamt).toFixed(2)}</td>
                ) : null}
              </tr>

            </table>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  )
}

export default Bonus
